/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Layout from '../../components/Layout';
import ServicesLayout from '../../components/ServicesLayout';
import AddEServices from './AddEServices';

import { isAdminUser } from '../../lib/utils';
import { adminEndpoint } from '../../config';

const title = 'Panel admina';

export default {
  path: adminEndpoint,
  children: [
    {
      path: '/',
      async action(ctx) {
        const isAdmin = await isAdminUser(ctx);
        if (!isAdmin) {
          return { redirect: '/' };
        }
        return {
          title,
          chunk: 'admin',
          component: <ServicesLayout isAdmin>hello{isAdmin}</ServicesLayout>,
        };
      },
    },
    require('./available_services').default,
    require('./service_cards').default,
    require('./service_creator').default,
    require('./district_declarations').default,
    require('./terms_of_use_editor').default,
    require('./service_cards_editor').default,
    require('./update_emuia').default,
    require('./claims').default,
    require('./districts').default,
    require('./users').default,
  ],
};

// {
//   path: '/disticts',
//   async action() {
//     return {
//       title,
//       chunk: 'disticts',
//       component:  <ServicesLayout isAdmin>Districts</ServicesLayout>,
//     };
//   }
// },
// {
//   path: '/users',
//   async action() {
//     return {
//       title,
//       chunk: 'users',
//       component:  <ServicesLayout isAdmin>users</ServicesLayout>,
//     };
//   }
// },
// {
//   path: '/docs',
//   async action() {
//     return {
//       title,
//       chunk: 'docs',
//       component:  <ServicesLayout isAdmin>docs</ServicesLayout>,
//     };
//   }
// },
// {
//   path: '/available_services',
//   async action() {
//     return {
//       title,
//       chunk: 'available_services',
//       component:  <ServicesLayout isAdmin>available_services</ServicesLayout>,
//     };
//   }
// },
// {
//   path: '/addeservices',
//   async action(ctx) {
//     return ensureAdmin(ctx, <ServicesLayout><AddEServices title={`dodawanie eusług`} /></ServicesLayout>);
//   }
// }



// WEBPACK FOOTER //
// src/routes/admin/index.js